import { useRouter } from "next/router";
import { useMemo } from "react";

export const useAddSlotsRouter = () => {
  const router = useRouter();
  const isFavorite = useMemo(() => router.query.filter === "favorite", [router.query.filter]);
  const isNew = useMemo(() => router.query.filter === "new", [router.query.filter]);
  const isHot = useMemo(() => router.query.filter === "hot", [router.query.filter]);
  const isChallenge = useMemo(() => router.query.filter === "challenges", [router.query.filter]);

  const slotsGridTitle = useMemo(() => {
    if (isHot) return "Hot Games";
    if (isFavorite) return "Favorite Slots";
    if (isChallenge) return "Challenge Games";
    return "New Releases";
  }, [isFavorite, isHot, isChallenge]);

  const isTabActive = (itemPath: string) => {
    const [itemBasePath, itemSearchParams] = itemPath.split("?");

    if (router.pathname !== itemBasePath) {
      return false;
    }

    const itemFilter = new URLSearchParams(itemSearchParams).get("filter");

    if (itemFilter) {
      return router.query.filter === itemFilter;
    }

    return !router.query.filter;
  };

  const challengeId =
    typeof router.query.challengeId === "string" ? router.query.challengeId : undefined;

  const challengeTitle =
    typeof router.query.challengeTitle === "string" ? router.query.challengeTitle : undefined;

  const challengeParams =
    isChallenge && challengeId && challengeTitle
      ? {
          id: challengeId,
          title: challengeTitle,
        }
      : null;

  const removeChallengeFilter = () => {
    const {
      challengeId: _challengeId,
      challengeTitle: _challengeTitle,
      ...restQuery
    } = router.query;

    router.push(
      {
        pathname: router.pathname,
        query: restQuery,
      },
      undefined,
      { shallow: true }
    );
  };

  const provider = typeof router.query.provider === "string" ? router.query.provider : "";

  const setProvider = (value: string) => {
    const { provider: _provider, ...restQuery } = router.query;

    router.push(
      {
        pathname: router.pathname,
        query: value ? { ...restQuery, provider: value } : restQuery,
      },
      undefined,
      { shallow: true }
    );
  };

  return {
    isNew,
    isFavorite,
    isHot,
    isChallenge,
    slotsGridTitle,
    isTabActive,
    challengeParams,
    removeChallengeFilter,
    provider,
    setProvider,
  };
};
